import { render, staticRenderFns } from "./pesoVolumetrico.vue?vue&type=template&id=b6059e88&scoped=true"
import script from "./pesoVolumetrico.vue?vue&type=script&lang=js"
export * from "./pesoVolumetrico.vue?vue&type=script&lang=js"
import style0 from "./pesoVolumetrico.vue?vue&type=style&index=0&id=b6059e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6059e88",
  null
  
)

export default component.exports